export default function () {
    return {
        errorResponse: null,
        successResponse: null,
        password: null,
        passwordConfirmation: null
    }
}
